export const stringItemIdsTogether = (itemIds: string[]) => {
    if (!itemIds) {
        return null;
    }
    let stringedItemIds = '';
    itemIds.forEach(itemId => {
        if (!!itemId) stringedItemIds = stringedItemIds + itemId + '|';
    });
    return stringedItemIds;
};
